import type { LPSettlementEventTypeEnum } from '@talos/kyoko';
import type { SettlementBatchRequestEvent } from '../generated/lpSettlementTypes';

export function toSettleBatchRequestEvent(row: {
  EventType: LPSettlementEventTypeEnum;
  EventID: string;
  Revision: number;
}): SettlementBatchRequestEvent {
  return {
    EventType: row.EventType,
    EventID: row.EventID,
    Revision: row.Revision,
  };
}
